export const GET_ZONES_LIST = "GET_ZONES_LIST";
export const GET_TECH_LIST = "GET_TECH_LIST";
export const GET_TECH_PROPERTY = "GET_TECH_PROPERTY";
export const GET_MAINTANANCE_CATEGORIES = "GET_MAINTANANCE_CATEGORIES";
export const GET_NEW_MAINTANANCE_CATEGORIES = "GET_NEW_MAINTANANCE_CATEGORIES";
export const GET_SP_TECHNICIANS = "GET_SP_TECHNICIANS";
export const GET_ALL_RECORDS_TECHNICIAN = "GET_ALL_RECORDS_TECHNICIAN";
export const GET_ALL_RECORDS_TECHNICIAN_SHIFTS = "GET_ALL_RECORDS_TECHNICIAN_SHIFTS";
